import { useContext } from 'react'
import { ThemeContext } from '../context';
import './sidepanel.css'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HomeIcon from '@mui/icons-material/Home';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddTaskIcon from '@mui/icons-material/AddTask';
import SettingsIcon from '@mui/icons-material/Settings';
import Bcmp from './Bcmp';


export default function Sidepanel() {
  const theme = useContext(ThemeContext)
  return (
    <div className={`sidepanel-${theme.currentTheme}`}>

      <div className='first-element'>

          <Bcmp name="Home" class="side-active" icon={<HomeIcon />}/>
          <Bcmp name="Reports" icon={<AssessmentIcon />}/>
          <Bcmp name="Explore" icon={<AddTaskIcon />}/>
          <Bcmp name="Advertising" icon={<AccountBalanceIcon />}/>
          <Bcmp name="Configure" icon={<AccountBalanceIcon />}/>

      </div>

      <div className='first-element'>
          <Bcmp name="Admin" icon={<SettingsIcon />}/>
      </div>

    </div>
  )
}
